<template>
  <navbar    
    position="fixed"
    type="white"    
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot="navbar-menu">
      <li class="nav-item">
        <nav-link
          to="/company"
          class="nav-link"
          v-html="$t('navbar.company')"
        />
        <!--<a class="nav-link" href="/company"><p> {{ $t("navbar.company") }}  </p> </a>-->
      </li>       
  

      <drop-down
        tag="li"
        :title="$t('navbar.services')"
        class="nav-item"
        position="left"             
      > 
        <nav-link
          to="/warehouse"
          class="dropdown-item"
          v-html="$t('navbar.warehouse')"
        >
          Warehouse and Distribution
        </nav-link>                    
        <nav-link
          to="/transportation"
          class="dropdown-item"
          v-html="$t('navbar.transport')"
        >
          Transportation
        </nav-link>                    
        <nav-link
          to="/freightbrokerage"
          class="dropdown-item"
          v-html="$t('navbar.freight')"
        >
          Freight Brokerage
        </nav-link>                    
      </drop-down>



      <li class="nav-item">
        <nav-link
          to="/contact"
          class="nav-link"
          v-html="$t('navbar.contact')"
        />
        <!--<a class="nav-link" href="/contact"> <p v-html="$t('navbar.contact')">Contact</p> </a>-->
      </li> 

      <li class="nav-item">
        <nav-link
          to="/career"
          class="nav-link"
          v-html="$t('Career.Career')"
        />
        <!--<a class="nav-link" href="/company"><p> {{ $t("navbar.company") }}  </p> </a>-->
      </li>       

      <!--  LANG  -->
      <!--
      <drop-down
              tag="li"
              v-bind:title="this.locale"
              class="nav-item"
              position="left"             
      > 
        <nav-link style="cursor: pointer;" v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang" @click.native="setLang(lang)">{{ lang }}</nav-link>
      </drop-down>
      -->
      <li class="nav-item">
        <nav-link
          class="nav-link pointer"
          @click.native="switchLang(locale)"
        >
          {{ locale }}
        </nav-link>
      </li> 
      <!-- END LANG   -->

      <drop-down
        tag="li"
        :title="$t('navbar.portal')"
        class="nav-item greenButton"
        white-text="true"
      >      
        <!--<nav-link to="/legacy" class="dropdown-item">Legacy Website </nav-link>      -->
        <a
          href="http://legacy.transplus.com"
          target="_blank"
          class="dropdown-item"
        > Legacy Website </a>    
        <!--<a href="http://evista.transplus.ca" target="_blank" class="dropdown-item"> Warehouse </a>    -->
        <nav-link
          to="/wms"
          class="dropdown-item"
        >
          Warehouse
        </nav-link>
                
        <!--
        <nav-link to="/chat">
          <i class="now-ui-icons users_circle-08"></i> Chat
        </nav-link>
        -->
        <!--<nav-link to="/screenshare" class="dropdown-item"> ScreenShare</nav-link>-->
      </drop-down>
      
      <li class="nav-item blueButton">
        <a
          class="nav-link blueButton"
          href="/quote"
          style="color:white"
        >{{ $t("navbar.quote") }}</a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button } from '@/components';
import { Popover } from 'element-ui';

export default {
  name: 'MainNavbar',
  components: {
    [Button.name]: Button,
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  data () {       
    return {
      langs: ['en','fr'],
      locale: 'fr'
    }
  },
  watch: {
    /*
    locale (val) {                 
      this.$i18n.locale = val
    }
    */
  },
  mounted(){

  },
  methods : {
    Services : function () {
      //alert(1)
      this.$router.push("services")
    },
    setLang : function (lang) {
      this.locale = lang
    },
    switchLang: function (lang) {
      
      if (lang === 'fr') {
        this.locale = 'en'        
        this.$i18n.locale = 'fr'
      } else {
        this.locale = 'fr'
        this.$i18n.locale = 'en'
      }

    }
  }  
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.nav-item{
  font-size:16px;
}
.nav-link.active{
  background-color:transparent;
}

.menuclass{
  background-color:whitesmoke;
  list-style: none; 
  color:black !important;
  padding: 10px; 
}
.menuclass > ul > li{  
  color:black !important;
}
.active {
    background-color:dodgerblue;
}
@media screen and (max-width: 991px) {
  .nav-item{
    font-size:2em;
  }  
  .greenButton {
    background-color: transparent;
    text-align: left;
  }
  a.blueButton{
    text-align: center;
    border-radius:0px;
    background-color: transparent;
    border: 1px solid white;
  }
  
}
</style>
